import React from 'react'
import { Grid, Segment } from 'semantic-ui-react'
import { useDispatch, useSelector, connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { useMount } from 'react-nb-hooks'
import { LKDate } from 'loankeeper-common/helpers/Date'
//@ts-ignore
import { SegmentGroup, GridContainer } from 'shared/StyledComponents'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
//@ts-ignore
import { DataSegment } from 'shared/Helpers'
//@ts-ignore
import LKModal, { actions as LKModalActions, LKModalTrigger } from 'shared/LKModal'

import { loadProductDetailsIfNeeded, getProductDetailsById } from '../../../../store/product'
import { LoadingIndicator } from '../../../shared/LoadingIndicator'
import translate, { translateLKMessage } from '../../translator'
import { actions } from '../../../DetailsContainer'
import LoanWriteOffModal, { LoanWriteOffModalTrigger } from './WriteOff'
import LoanWriteOffDataModal, { LoanWriteOffDataModalTrigger } from './WriteOffData'
import NodeDropdown from './NodeDropdown'
import ResourceDropdown from './ResourceDropdown'
import AgreementNumberInput from './AgreementNumberInput'
import LoanAdditionalInfo from './LoanAdditionalInfo'

import { OtherTabProps, OtherResourceData, OtherNode } from '../../types.LoanDetails'
import { WriteOffUndoParams } from '@lk/api'
import { undoWriteOff } from 'src/store/loan'
import { AppDispatch } from 'src/store/index.d'

const transformOptions = (options: OtherResourceData[] | OtherNode[]) =>
  options.map((option: OtherResourceData | OtherNode) => ({
    key: option.ID,
    value: option.ID,
    text: option.Title,
  }))

const style = {
  firstSegment: {
    padding: '5px',
    borderBottom: '1px solid rgba(34,36,38,.15)',
  },

  noTopBorder: {
    borderTop: 'none',
    borderBottom: '1px solid rgba(34,36,38,.15)',
  },
}

const withValidationRules = (Component) => (props: OtherTabProps) => {
  const { ProductID, HashSum_ProductID_ } = props.data
  const dispatch = useDispatch()

  const productDetailsResult = useSelector((state) => getProductDetailsById(state, ProductID))

  useMount(() => {
    dispatch(loadProductDetailsIfNeeded({ productId: ProductID, productHash: HashSum_ProductID_ }))
  })

  if (!productDetailsResult) {
    return <LoadingIndicator />
  }

  return <Component {...props} nodes={productDetailsResult.Node_LKP} resources={productDetailsResult.Resource} />
}

@withRouter
@withConstantPermissions()
//@ts-ignore
@withValidationRules
//@ts-ignore
@connect(undefined, (dispatch: AppDispatch, ownProps: OtherTabProps) => ({
  openErrorDialog: (message: string) => dispatch(LKModalActions.openInfo(message)),

  fetchBase: () => dispatch(actions.fetchPage({ type: 'Loan', ID: ownProps.ID, hash: ownProps.hash, page: 'base' })),
  undoWriteOff: (params: Omit<WriteOffUndoParams, 'page'>) => dispatch(undoWriteOff(params)),
}))
class Other extends React.PureComponent<OtherTabProps> {
  confirmUndoLoanWriteOff = async () => {
    const { fetchBase, openErrorDialog, ID, hash } = this.props

    try {
      // await Loan.loanOper({
      //   page: 'writeoffundo',
      //   LoanID: ID,
      //   HashSum_LoanID_: hash,
      // })

      //UPDATED API REQUEST loan_oper_api page: writeoffundo
      const writeOffUndoParams = await this.props.undoWriteOff({
        LoanID: ID,
        HashSum_LoanID_: hash,
      })

      if (!undoWriteOff.fulfilled.match(writeOffUndoParams)) {
        throw { Error: { Message: writeOffUndoParams.payload } }
      }

      fetchBase()
    } catch ({ Error: { Message, Text } }) {
      openErrorDialog(translateLKMessage(Message || Text))
    }
  }

  render() {
    const {
      data,
      data: { ResourceID, AgreementNo, NodeID, StateID, WriteOffDate, IsArrested, ClientID, HashSum_ClientID_ },
      resources,
      nodes,
      ID,
      hash,
      permissions,
    } = this.props

    let firstSegmentComponent = null
    if (StateID === 4) {
      if (permissions.UNDO_LOAN_WRITEOFF) {
        firstSegmentComponent = (
          <Grid.Row>
            <Grid.Column width={2}>
              <DataSegment>{translate('pan_wo_date')}</DataSegment>
            </Grid.Column>

            <Grid.Column width={2}>
              <DataSegment>{LKDate.from(WriteOffDate).toString()}</DataSegment>
            </Grid.Column>

            <Grid.Column width={1}>
              {IsArrested !== 1 && <LoanWriteOffDataModalTrigger />}

              <LoanWriteOffDataModal ID={ID} hash={this.props.hash} />
            </Grid.Column>

            <Grid.Column width={3}>
              <LKModalTrigger
                params={{ message: translateLKMessage('CONFIRM_UNDO_WOFF') }}
                name="UNDO_LOAN_WRITE_OFF_MODAL"
                alias="undo"
              >
                {translate('cmd_undo_writeoff')}
              </LKModalTrigger>

              <LKModal.Confirmation name="UNDO_LOAN_WRITE_OFF_MODAL" onConfirm={this.confirmUndoLoanWriteOff} />
            </Grid.Column>
          </Grid.Row>
        )
      }
    } else if (permissions.LOAN_WRITEOFF) {
      firstSegmentComponent = (
        <Grid.Row>
          <Grid.Column width={3}>
            <LoanWriteOffModalTrigger />

            <LoanWriteOffModal
              ID={this.props.ID}
              hash={this.props.hash}
              ClientID={ClientID}
              clientHash={HashSum_ClientID_}
            />
          </Grid.Column>
        </Grid.Row>
      )
    }

    return (
      <SegmentGroup>
        <Segment.Group>
          <Segment style={style.firstSegment}>
            <GridContainer>
              <Grid>{firstSegmentComponent}</Grid>
            </GridContainer>
          </Segment>

          <Segment style={style.noTopBorder}>
            <GridContainer>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={5} style={{ display: 'flex', flexDirection: 'row' }} verticalAlign="middle">
                    <ResourceDropdown
                      options={transformOptions(resources)}
                      initialValue={ResourceID}
                      ID={ID}
                      hash={hash}
                    />
                  </Grid.Column>

                  <Grid.Column width={5} style={{ display: 'flex', flexDirection: 'row' }} verticalAlign="middle">
                    <AgreementNumberInput initialValue={AgreementNo} ID={ID} hash={hash} />
                  </Grid.Column>

                  <Grid.Column width={5} style={{ display: 'flex', flexDirection: 'row' }} verticalAlign="middle">
                    <NodeDropdown options={transformOptions(nodes)} initialValue={NodeID} ID={ID} hash={hash} />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </GridContainer>
          </Segment>
          {/*@ts-ignore*/}
          <LoanAdditionalInfo data={data} />
        </Segment.Group>
      </SegmentGroup>
    )
  }
}

//@ts-ignore
Other.defaultProps = {
  data: {},
  resources: [],
  nodes: [],
}

export default Other
